/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Unsupported_SchemeInputs */

const en_site_url_error_unsupported_scheme = /** @type {(inputs: Site_Url_Error_Unsupported_SchemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only http:// or https:// addresses can be dissected.`)
};

const id_site_url_error_unsupported_scheme = /** @type {(inputs: Site_Url_Error_Unsupported_SchemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya alamat http:// atau https:// yang bisa dibedah.`)
};

/**
* | output |
* | --- |
* | "Only http:// or https:// addresses can be dissected." |
*
* @param {Site_Url_Error_Unsupported_SchemeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_unsupported_scheme = /** @type {((inputs?: Site_Url_Error_Unsupported_SchemeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Unsupported_SchemeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_unsupported_scheme(inputs)
	return en_site_url_error_unsupported_scheme(inputs)
});